import { BrowserRouter, Route, Routes, } from "react-router-dom";
import AppProvider from './context/AppContext'
import './assets/styles/index.scss';
import Login from './pages/Login';
import Dashboard from './pages/dashboard';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { URLAPP } from "./config";


function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path={`${URLAPP.root}/*`} element={<Dashboard />} />
            <Route path="*" element={<Login />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
